import { useMemo } from "react";

import { CbhFeatureFlag, useCbhFlag } from "../FeatureFlags";
import { useDefinedWorker } from "../Worker/useDefinedWorker";
import { isCustomWorkerShoppableQualification } from "./utils";

// We assume the only way a worker has access to fetch
// custom qualifications is through shoppable qualifications
// We intentionally hide custom qualifications from workers. If we come across a custom qualification,
// we need to substitute it with the base qualification name. Any user facing text should
// be based on the base qualification
export function useWorkerCustomToBaseQualificationNameMap() {
  const { shoppableQualifications } = useDefinedWorker();
  const isCustomQualificationsEnabled = useCbhFlag(CbhFeatureFlag.CUSTOM_QUALIFICATIONS, {
    defaultValue: false,
  });

  return useMemo(() => {
    const map = new Map<string, string>();
    if (!isCustomQualificationsEnabled) {
      return map;
    }

    shoppableQualifications.forEach((shoppableQualification) => {
      if (isCustomWorkerShoppableQualification(shoppableQualification)) {
        const { data: qualification } = shoppableQualification.relationships.qualification;
        map.set(qualification.name, qualification.baseQualificationName);
      }
    });

    return map;
  }, [shoppableQualifications, isCustomQualificationsEnabled]);
}
